var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"quick-view-btn",on:{"click":_vm.buttonClick}},[_c('img',{attrs:{"src":"/ui/main/img/quick-view.svg","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }